module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG0004-f23d366e85d92ecef70a4cbc0bcf24c4.png";